import styles from './Loaders.module.scss'
import {useGlobalValue} from "elum-state/react";
import {THEME} from "../../../state/elum";
export const Skeleton = () => {
    const theme = useGlobalValue(THEME)
    return (
        <div className={`${styles[theme]} ${styles.skeleton}`}/>
    )
}
